<div class="common-progress-bar progress">
	<div class="progress-bar bg-green" role="progressbar" [style.width.%]="percentage()" [attr.aria-valuenow]="percentage()" aria-valuemin="0"
		aria-valuemax="100"></div>
</div>